import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  gap: "$md",
  paddingTop: "$lg",
  paddingLeft: "$xl",
  paddingRight: "$xl",
  justifyContent: "flex-end",
  order: "3"
});